import designs from './designs.json'
import automations from './automations.json'
import forms from './forms.json'
import checklists from './checklists.json'
import type { TemplateRegistryEntry } from '../../types/templates'

// Code-only Explore catalogue. Editing any *.json file in this folder is a
// registry mutation — bump the entry's `registryVersion` in the same PR so
// existing workspace clones surface the "template changed" badge.

export const BUNDLED_EXPLORE_TEMPLATES: TemplateRegistryEntry[] = [
  ...(designs as TemplateRegistryEntry[]),
  ...(automations as TemplateRegistryEntry[]),
  ...(forms as TemplateRegistryEntry[]),
  ...(checklists as TemplateRegistryEntry[]),
]

export const getBundledExploreTemplate = (templateId: string) =>
  BUNDLED_EXPLORE_TEMPLATES.find((template) => template.id === templateId) ?? null
